import { DOMNode, Element as ParserElement } from 'html-react-parser'
import funkitaTheme from '../../app/styles/funkita.module.scss'
import funkytrunksTheme from '../../app/styles/funkytrunks.module.scss'
import * as appApi from '../../services/app/app.api'

const getCurrentTheme = () => {
  const appDiv = document.getElementById('app')
  const themeDiv = appDiv?.firstElementChild as HTMLElement
  const themeClass = themeDiv?.className || ''
  return themeClass.includes('funkytrunks') ? funkytrunksTheme : funkitaTheme
}

const replaceCssVariables = (styles: string) => {
  const theme = getCurrentTheme()

  return styles.replace(/var\((--[\w-]+)\)/g, (match, variableName) => {
    const themeKey = variableName.replace('--', '')
    const themeValue = theme[themeKey]
    return themeValue || match
  })
}

export const extractAndRemoveStyle = (content: string) => {
  const styleTagRegex = /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi
  const extractedStyles = []
  let match
  while ((match = styleTagRegex.exec(content)) !== null) {
    const processedStyle = replaceCssVariables(match[0])
    extractedStyles.push(processedStyle)
  }

  const cleanContent = content.replace(styleTagRegex, '')

  return {
    cleanContent,
    extractedStyles,
  }
}

export const processHtmlLinks = async (html: string, canonicalDomain: string): Promise<string> => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')

  const links = doc.querySelectorAll('a')
  const promises = Array.from(links).map(async link => {
    const href = link.getAttribute('href') || link.getAttribute('data-href')
    if (href) {
      const result = await findAndReplaceLink(href, canonicalDomain)
      if (result && typeof result === 'string') {
        link.setAttribute('href', result)
      } else {
        link.setAttribute('href', href)
      }
    }
  })

  await Promise.all(promises)

  return doc.documentElement.querySelector('body')?.innerHTML || ''
}

export const findAndReplaceLink = async (link: string, canonicalDomain: string) => {
  let newUrl: string | false = false
  try {
    const redirect = await appApi.readRedirectFrom(link, canonicalDomain)
    newUrl = redirect.data?.to
  } catch (e) {
    console.error(e)
  }

  return newUrl
}

export const domNodeIsElement = (domNode: DOMNode): domNode is ParserElement => {
  return domNode.type === 'tag'
}
